<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip }">
      <span
        v-on="tooltip"
      >
        <v-btn
          :class="classes ? classes.join(' ') : ''"
          :icon="!!icon || !!image"
          :outlined="!!outlined"
          :small="!!small"
          @click="$emit('click')"
          :disabled="disabled"
          :text="!!text"
          :color="color"
          :block="!!block"
          :style="!!border ? 'border:2px solid red;' : ''"
          :href="href ? href : undefined"
          :target="href ? '_blank' : undefined"
          :rel="href ? 'noopener noreferrer' : undefined"
        >
          <v-icon
            v-if="icon" :small="!!small"
          >{{ icon }}</v-icon>
          <span v-if="btnText">{{ btnText }}</span>
          <img
            v-if="image" :src="image"
            :style="!!border ? `border:2px solid ${border};` : ''"
          />
        </v-btn>
      </span>
    </template>
    <slot></slot>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TooltipBtn',
  props: [
    'icon',
    'btnText',
    'block',
    'disabled',
    'image',
    'small',
    'color',
    'border',
    'outlined',
    'classes',
    'href',
    'text',
  ],
  methods: {
  },
};
</script>

<style>

</style>
